import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-sign-road-1",
  "use": "icon-si-glyph-sign-road-1-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-sign-road-1\" id=\"icon-si-glyph-sign-road-1\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1111</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M13.447,3.902 L16.812,2.562 L13.447,1.071 L9.959,1.071 L9.959,0.167 L9.057,0.167 L9.057,1.071 L5.101,1.071 L5.101,3.902 L9.057,3.902 L9.057,6.059 L4.566,6.059 L1.083,7.531 L4.566,8.943 L9.057,8.943 L9.057,14.974 L9.959,14.974 L9.959,8.943 L12.976,8.943 L12.976,6.059 L9.959,6.059 L9.959,3.902 L13.447,3.902 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-sign-road-1.svg
// module id = E476
// module chunks = 62